<template>
    <vue-select
        :value="value"
        @input="handleInput"
        v-if="Array.isArray(options)"
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på adress</em>
        </template>
    </vue-select>
</template>
<script>
import apiClient from '@services/ApiClient';
import VueSelect from '@components/Wrappers/VueSelect.vue';

export default {
    name: 'EcardTemplateFilter',
    props: {
        value: null,
        customerId: {
            type: Number,
            required: true,
        },
        useView: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        VueSelect,
    },
    data() {
        return {
            options: null,
        };
    },
    mounted() {
        this.getOptions(this.customerId);
    },
    watch: {
        customerId(newVal) {
            this.getOptions(newVal);
        },
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
        getOptions(customerId) {
            apiClient.get('/vue/ecard/templates?per_page=1000&customer_id=' + customerId)
                .then((response) => {
                    this.options = response.data.data.map((template) => ({
                        id: template.TemplateID,
                        label: template.TemplateName + ' (' + template.SenderName + ')',
                        ...template,
                    })).filter((t) => !!(t.use_view) === !!(this.useView));
                });
        },
    },
};
</script>
